class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.onToggleClickHandler = this.onToggleClick.bind(this);
    this.onDocumentKeyUpHandler = this.onDocumentKeyUp.bind(this);
    this.onDocumentClickHandler = this.onDocumentClick.bind(this);
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;

    this.toggleButton = this.querySelector('[data-modal-toggle]');
    this.dialogElement = this.querySelector('[data-modal-dialog]');
    if (!this.toggleButton || !this.dialogElement) return;

    this.toggleButton.addEventListener('click', this.onToggleClickHandler);
    document.addEventListener('keyup', this.onDocumentKeyUpHandler);
    this.addEventListener('click', this.onClickHandler);

    this.toggleButton.setAttribute('aria-haspopup', 'dialog');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    if (!this.dialogElement.id) {
      DetailsModal.instanceCount = (DetailsModal.instanceCount || 0) + 1;
      this.dialogElement.id = `SearchModal-${DetailsModal.instanceCount}`;
    }
    this.toggleButton.setAttribute('aria-controls', this.dialogElement.id);
    this.dialogElement.setAttribute('role', 'dialog');
    this.dialogElement.setAttribute('aria-modal', 'true');
    if (!this.dialogElement.hasAttribute('hidden')) {
      this.dialogElement.setAttribute('hidden', 'hidden');
    }

    this.initialized = true;
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.toggleButton.removeEventListener('click', this.onToggleClickHandler);
    document.removeEventListener('keyup', this.onDocumentKeyUpHandler);
    document.removeEventListener('click', this.onDocumentClickHandler);
    this.removeEventListener('click', this.onClickHandler);
    this.initialized = false;
  }

  onDocumentKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE' && this.isOpen()) {
      this.close();
    }
  }

  onDocumentClick(event) {
    if (!this.isOpen()) return;
    if (this.contains(event.target)) return;
    this.close(false);
  }

  onClick(event) {
    if (event.target.closest('.search-modal__close-button')) {
      event.preventDefault();
      this.close();
    }
  }

  isOpen() {
    return this.toggleButton.getAttribute('aria-expanded') === 'true';
  }

  onToggleClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.dialogElement.removeAttribute('hidden');
    this.classList.add('is-open');
    document.addEventListener('click', this.onDocumentClickHandler);
    document.body.classList.add('overflow-hidden');

    const initialFocusElement =
      this.dialogElement.querySelector('input[type="search"]:not([disabled])') ||
      this.dialogElement.querySelector('input:not([type="hidden"]):not([disabled])') ||
      this.dialogElement.querySelector('.search-modal__close-button') ||
      this.dialogElement.querySelector('.modal__close-button') ||
      this.dialogElement;

    trapFocus(this.dialogElement, initialFocusElement);
  }

  close(focusToggle = true) {
    if (!this.initialized) return;
    removeTrapFocus(focusToggle ? this.toggleButton : null);
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.dialogElement.setAttribute('hidden', 'hidden');
    this.classList.remove('is-open');
    document.removeEventListener('click', this.onDocumentClickHandler);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
